import LecomRefluxEvents from './events/lecom_reflux_events';
import EventHandler from '../events/event_handler';
import { iterate } from '../utils/object_iterator';
import { serializePrivateProperties } from '../utils/object_utils';
import { generateUUID } from 'utils/uuid';

export default {
	storeItemClass: class {},
	eventHandler: new EventHandler(),
	events: LecomRefluxEvents,
	store: {},
	initialized: false,

	onInit(itemId, properties = {}) {
		this.store[itemId] = new this.storeItemClass(Object.assign({}, properties));
		this._afterConstruct(this.store[itemId]);

		this._publish(this.events.INIT, ...arguments);
	},

	_afterConstruct(storeItem) {
		this.postConstruct && this.postConstruct(storeItem);
		this.initialized = true;
	},

	onSetState(itemId) {
		const publishEvent = this._publish.bind(this, this.events.SET_STATE, ...arguments);
		this._setState(itemId).then(publishEvent);
	},

	onSetProperty(itemId, propertyName, value, trigger = true) {
		const publishEvent = this._publish.bind(this, this.events.SET_PROPERTY, ...arguments);

		this._setProperty(itemId, propertyName, value, trigger)
		.then(publishEvent);
	},

	onSetProperties(itemId, properties, trigger = true) {
		const publishEvent = this._publish.bind(this, this.events.SET_PROPERTIES, ...arguments);

		this
		._setProperties(itemId, properties, trigger)
		.then(publishEvent);
	},

	getProperty(itemId, propertyName) {
		const storeItem = this._getStoreItem(itemId);
		return storeItem ? storeItem[propertyName] : null;
	},

	getProperties(itemId, ...properties) {
		const storeItem = this._getStoreItem(itemId);
		return this._getModelProperties(storeItem, ...properties);
	},

	_setProperty(itemId, propertyName, value, trigger = true) {
		return this._setProperties(itemId, { [propertyName]: value }, trigger)
	},

	_setProperties(itemId, properties, trigger = true) {
		const storeItem = this._getStoreItem(itemId);
		return this._setModelProperties(itemId, storeItem, properties, trigger);
	},

	_getModelProperties(model, ...properties) {
		const modelProperties = serializePrivateProperties(model);

		return Object.keys(modelProperties)
		.filter((k) => properties.length === 0 || properties.indexOf(k) > -1)
		.reduce((props, k) => {
			props[k] = modelProperties[k];
			return props;
		}, {});
	},

	_setModelProperties(itemId, model, properties, trigger = true) {
		for(let [propertyName, value] of iterate(properties)) {
			model[propertyName] = value;
		}

		model['updateUUID'] = generateUUID();

		return (trigger)
			? this._setState(itemId)
			: Promise.resolve();
	},

	_getStoreItem(itemId) {
		const storeItem = this.store[itemId];
		if(!storeItem) {
			throw new Error(`Store Item not found for id: ${itemId}`);
		}

		return storeItem;
	},

	_setState(itemId) {
		return new Promise((resolve) => this.trigger(this.store, itemId, resolve));
	},

	_publish(eventName, ...args) {
		this.eventHandler.publish.call(this.eventHandler, eventName, ...args);
		return Promise.resolve();
	}
};
